import { render, staticRenderFns } from "./SmsSendStep.vue?vue&type=template&id=06e5f882&scoped=true"
import script from "./SmsSendStep.vue?vue&type=script&lang=js"
export * from "./SmsSendStep.vue?vue&type=script&lang=js"
import style0 from "./SmsSendStep.vue?vue&type=style&index=0&id=06e5f882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e5f882",
  null
  
)

export default component.exports